<template>
  <!--Footer off the website-->
  <footer id="footer" class="text-white">
    <div class="container container-footer">
      <div class="row pt-5 pb-5">
        <div class="col-md-3">
          <div class="footer-seccion">
            <div class="footer-msj-div">
              <ul class="p-0 mb-0">
                <li>Expertos en microblading</li>
                <li> y micropigmentación</li>
              </ul>

              <div class="social-links-footer">
                <ul class="pl-0">
                  <li>
                    <a
                      href="https://www.instagram.com/yariestilospmu?igsh=NWswOWF2cGhteTg4/"
                      target="_blank"
                      ><img decoding="async" src="../../public/img/instagram.webp" alt="instagram"
                    /></a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/yaretzi.ocanto?mibextid=LQQJ4d"
                      target="_blank"
                      ><img decoding="async" src="../../public/img/facebook-2.webp" alt="facebook"
                    /></a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/@YariestilosMicropigmentacion"
                      target="_blank"
                      ><img decoding="async" src="../../public/img/youtube-1.webp" alt="youtube"
                    /></a>
                  </li>
                  <li>
                    <a
                      href="https://wa.me/message/SPVSEMNIC5JHN1"
                      target="_blank"
                      ><img decoding="async" src="../../public/img/whatsapp-1.webp" alt="whatsapp"
                    /></a>
                  </li>
                  
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="footer-seccion">
            <div class="div-footer-h">
              <h4>Link</h4>
              <ul class="pl-0">
                <li class="list-group-item link-hover-footer pt-0">
                  <a href="#" class="text-white">INICIO</a>
                </li>
                <li class="list-group-item link-hover-footer pt-0">
                  <a href="#" class="text-white">INICIAR SESIÓN</a>
                </li>
                <li class="list-group-item link-hover-footer pt-0">
                  <a href="#" class="text-white">REGISTRATE</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="footer-seccion">
            <div class="div-footer-h">
              <h4>Horarios</h4>
              <ul class="pl-0">
                <li>LUN - VIE: 10AM - 2PM</li>
                <li>SÁBADOS: 11AM - 5PM</li>
                <li>DÓMINGOS: CERRADO</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="footer-seccion">
            <div class="div-footer-h">
              <h4>Información</h4>
              <ul class="info-iconos text-left pl-0">
                <li class="pe-0" style="padding-left: 0 !important;">
                  <a
                    href="https://g.page/TeboriBrows?share"
                    class="text-white"
                    target="_blank"
                    >Barquisimeto Estado Lara</a
                  >
                </li>
                <li style="padding-left: 0 !important;">
                  <a href="tel:+584245124623" target="_blank" class="text-white"
                    >(0424) 512-46-23</a
                  >
                </li>
                <li style="padding-left: 0 !important;">
                  <a
                    href="mailto:@yariestilospmu0@gmail.com"
                    class="text-white"
                    target="_blank"
                    >yare.ocanto.yo@gmail.com</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row footer-copyright-seccion">
      <div class="pt-4 m-auto mt-1 p-2">
        <div class="container">
          <p class="text-footer-botom">
            © 2021 YARIESTILOS PMU, Todos los derechos reservados.
          </p>
        </div>
      </div>
    </div>
  </footer>
  <!--End Footer off the website-->
</template>

<script>
import image from "../../public/img/whatsapp-1.webp"
export default {
  name: "TheFooter",
};
</script>

<style scoped>
/* --------------------------footer--------------------------*/
.container-footer {
  max-width: 1338px !important;
}
.social-links-footer {
  margin-top: 33px;
}
.social-links-footer ul {
  margin-left: 0px;
  list-style: none;
}
.social-links-footer ul li {
  display: inline-block;
  margin-right: 7px;
}
.social-links-footer ul li a img {
  height: 38px;
}
.footer-msj-div {
  font-family: "Playfair Display", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  color: #f2e7df !important;
  font-size: 41px;
  
}
.footer-msj-div li{
 font-size:  24px;
}
.link-hover-footer:hover {
  cursor: pointer;
}
ul {
  list-style: none outside;
}
.div-footer-h ul li {
  padding: 0px 5px !important;
  
  border: 1px solid rgba(0, 0, 0, 0.04);
  font-weight: 500 !important;
  text-transform: uppercase !important;
  font-size: 15px !important;
  color: #f2e7df !important;
  letter-spacing: 1px !important;
}

ul.info-iconos li {
  padding-left: 45px !important;
 
  background-position: top 0px left;
  background-repeat: no-repeat;
  background-size: 30px;
 
  
}

.text-footer-botom {
  font-size: 20px;
  font-family: "Playfair Display", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif !important;
}
.footer-copyright-seccion {
  background-color: #202020;
  border-top: 1px solid #f9e0bb5e;
  padding-bottom: 15px;
}

#footer {
  background-color: #202020;
}
/*--------------------------------------------------------------End Footer--------------------------------------------------------------*/
</style>
